import { render, staticRenderFns } from "./FGroupText.vue?vue&type=template&id=2cd89310&"
import script from "./FGroupText.vue?vue&type=script&lang=js&"
export * from "./FGroupText.vue?vue&type=script&lang=js&"
import style0 from "./FGroupText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports